export class ProtocoloDetalle {
  private id_ot: number;
  private fecha: Date;
  private muestra: string;
  private nombre: string;
  private codigo: string;
  private mnemonico: string;
  private descripcion: string;
  private procesar: boolean;

  constructor(
    id_ot: number,
    fecha: Date,
    muestra: string,
    nombre: string,
    codigo: string,
    mnemonico: string,
    descripcion: string,
    procesar: boolean
  ) {
    this.id_ot = id_ot;
    this.fecha = fecha;
    this.muestra = muestra;
    this.nombre = nombre;
    this.codigo = codigo;
    this.mnemonico = mnemonico;
    this.descripcion = descripcion;
    this.procesar = procesar;
  }

  // Getters and Setters

  public getIdOt(): number {
    return this.id_ot;
  }

  public setIdOt(id_ot: number): void {
    this.id_ot = id_ot;
  }

  public getFecha(): Date {
    return this.fecha;
  }

  public setFecha(fecha: Date): void {
    this.fecha = fecha;
  }

  public getMuestra(): string {
    return this.muestra;
  }

  public setMuestra(muestra: string): void {
    this.muestra = muestra;
  }

  public getNombre(): string {
    return this.nombre;
  }

  public setNombre(nombre: string): void {
    this.nombre = nombre;
  }

  public getCodigo(): string {
    return this.codigo;
  }

  public setCodigo(codigo: string): void {
    this.codigo = codigo;
  }

  public getMnemonico(): string {
    return this.mnemonico;
  }

  public setMnemonico(mnemonico: string): void {
    this.mnemonico = mnemonico;
  }

  public getDescripcion(): string {
    return this.descripcion;
  }

  public setDescripcion(descripcion: string): void {
    this.descripcion = descripcion;
  }

  public getProcesar(): boolean {
    return this.procesar;
  }

  public setProcesar(procesar: boolean): void {
    this.procesar = procesar;
  }

  // Método estático para mapear una colección de objetos de la API a ProtocoloDetalle
  public static fromCollection(data: any[]): ProtocoloDetalle[] {
    return data.map(
      (item) =>
        new ProtocoloDetalle(
          item.id_ot,
          new Date(item.fecha), // Asegurarse de convertir el string a Date
          item.muestra,
          item.nombre,
          item.codigo,
          item.mnemonico,
          item.descripcion,
          item.procesar
        )
    );
  }
}
